export default __webpack_public_path__ + "static/media/Raleway-Black.eef1ff81.ttf";